import { supabase } from './supabaseClient';

const META = 'id,team,kind,file_hash,scope_hash,observed_at,created_at,filename,original_path,sources,totals,part_count';
const requireData = ({data,error}) => { if (error) throw new Error(error.message); return data; };

export function createStockApi(client = supabase) {
  return {
    async save(task) {
      if (task.file) {
        const {error} = await client.storage.from('stock-originals').upload(task.event.file_hash,task.file,{upsert:false,contentType:task.file.type || 'application/octet-stream'});
        if (error && !['409','Duplicate'].includes(String(error.statusCode || error.error)) && !/already exists/i.test(error.message || '')) throw new Error(error.message);
      }
      const saved = requireData(await client.rpc('rg_stock_capture',{p_event:task.event,p_parts:task.parts,p_document:task.document}));
      const verified = requireData(await client.from('stock_uploads').select('id,report_id,is_repeat').eq('id',task.event.id).single());
      if (!saved?.report_id || verified?.report_id !== saved.report_id) throw new Error('Server save could not be verified. Retry the pending save.');
      return verified;
    },
    async timeline({team,kind,from,to,part=''}) {
      const rows=[];
      // PostgREST applies its row limit to RPCs too. Always paginate years of data.
      for(let start=0;;start+=1000) {
        const page=requireData(await client.rpc('rg_stock_timeline',{p_team:team,p_kind:kind,p_from:from,p_to:to,p_part:part}).range(start,start+999));
        rows.push(...page); if(page.length<1000) return rows;
      }
    },
    async reports({team,kind,from,to,page=0}) {
      // Use UTC envelope then exact London filtering in the timeline view.
      const result=await client.from('stock_reports').select(META,{count:'exact'}).eq('team',team).eq('kind',kind)
        .gte('observed_at',from).lt('observed_at',to).order('observed_at',{ascending:false}).order('created_at',{ascending:false}).order('id',{ascending:false}).range(page*25,page*25+24);
      return {rows:requireData(result),count:result.count};
    },
    async parts(reportId,search='',page=0) {
      let query=client.from('stock_parts').select('*',{count:'exact'}).eq('report_id',reportId);
      if(search) query=query.ilike('part_id','%'+search.replace(/[\\%_]/g,'\\$&')+'%');
      const result=await query.order('part_id').range(page*100,page*100+99);
      return {rows:requireData(result),count:result.count};
    },
    async report(id) { return requireData(await client.from('stock_reports').select('*').eq('id',id).single()); },
    async source(eventId) {
      const event=requireData(await client.from('stock_uploads').select('report_id').eq('id',eventId).single());
      return requireData(await client.from('stock_reports').select(META).eq('id',event.report_id).single());
    },
    async events(id) { return requireData(await client.from('stock_uploads').select('id,filename,is_repeat,created_at').eq('report_id',id).order('created_at',{ascending:false}).limit(100)); },
    async original(path) { return requireData(await client.storage.from('stock-originals').download(path)); },
  };
}
export const stockApi = createStockApi();
